/**
 * Both Connect surfaces use account sessions from the configured accounts backend.
 * Their publishable key must belong to that same Stripe platform. A separate
 * onboarding-only key can authenticate against a different platform in development.
 */

export function getStripeConnectPublishableKeyForDashboard() {
  return import.meta.env.VITE_APP_STRIPE_PK;
}

export function getStripeConnectPublishableKeyForOnboarding() {
  return getStripeConnectPublishableKeyForDashboard();
}
